import type { ButtonHTMLAttributes, ReactNode } from 'react';

import css from './Boton.module.css';

export type Variante = 'primario' | 'oscuro' | 'secundario' | 'peligro' | 'texto' | 'cuadrado';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
    variante?: Variante;
    children: ReactNode;
}

/**
 * El botón.
 *
 * Las alturas salen del handoff y no son negociables: 58 px el primario,
 * 50 el secundario, 56 los de la barra inferior. El mínimo de 44 px de zona
 * pulsable lo garantiza además la hoja global, para que no dependa de que
 * alguien se acuerde aquí.
 */
export function Boton({ variante = 'primario', children, type = 'button', ...resto }: Props) {
    return (
        <button type={type} className={`${css.base} ${css[variante]}`} {...resto}>
            {children}
        </button>
    );
}
